export default __webpack_public_path__ + "static/media/Stainless-steel-coil.0f9d22db.jpg";